module.exports = __webpack_public_path__ + "img/zhang1.f9325f35.png";